import React, { useState }            from 'react'
import {
    Box, Button, Container,
    FormControl, Grid, Paper,
    Stack, TextField, Typography
}                                     from '@mui/material'
import { useTranslation }             from 'react-i18next'
import Page                           from '../../components/Page'
import { useApi }                     from '../../utils/api'
import { useSnackbar }                from 'notistack'
import AlertSimpleDialog              from '../../components/alert-simple-dialog'

export default function SmsBroadcastPage () {
    // eslint-disable-next-line no-unused-vars -- ToDo - api call
    const api = useApi()
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const [smsContent, setSmsContent] = useState('')
    const [recipientDetails, setRecipientDetails] = useState('')
    const [shownSendDialog, setShownSendDialog] = useState(false)
    
    const sendSms = async () => {
        const lines = recipientDetails.split('\n')
        // eslint-disable-next-line no-unused-vars -- ToDo - api call
        const items = lines.map(line => {
            const [telTo, telFrom, operator] = line.split(';')
            return { telTo, telFrom, operator }
        })
        try {
            // ToDo - api call
            enqueueSnackbar(t('Messages sent successfully'), {
                variant: 'success'
            })
        } catch (e) {
            enqueueSnackbar(t('Failed to send messages'), {
                variant: 'error'
            })
        }
    }

    const validateInputs = () => {
        if (!smsContent.trim() || !recipientDetails.trim()) {
            enqueueSnackbar(t('Message text or recipient list is missing'), {
                variant: 'error'
            });
            return false
        }
        const lines = recipientDetails.split('\n')
        for (const line of lines) {
            const trimmed = line.trim()
            if (trimmed === '') {
                continue
            }
            const parts = trimmed.split(';').map(p => p.trim())
            if (parts.length !== 3) {
                enqueueSnackbar(t('invalid-line-format', { line: trimmed }), {
                    variant: 'error'
                })
                return false
            }
            const [telTo, telFrom, operator] = parts
            if (!/^\+421\d{9}$/.test(telTo) || !/^\d{4}$/.test(telFrom) || !/^\d{5}$/.test(operator)) {
                enqueueSnackbar(t('invalid-line-format', { line: trimmed }), {
                    variant: 'error'
                })
                return false
            }
        }
        return true
    }

    const handleSendClick = () => {
        if (validateInputs()) {
            setShownSendDialog(true)
        }
    }

    const handleSendDialogClose = (confirmed) => {
        setShownSendDialog(false)
        if (!confirmed) {
            return
        }
        sendSms()
    }

    return (
        <Page title={t('Sms broadcast')}>
            <Container>
                <Stack direction="row" alignItems="center" mb={4} spacing={2}>
                    <Typography variant="h4" gutterBottom>{t('Sms broadcast')}</Typography>
                </Stack>
                <Container>
                    <Paper sx={{ p:1 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl variant="standard" fullWidth>
                                    <TextField
                                        id="sms-content"
                                        label={t('Sms content')}
                                        multiline
                                        minRows={3}
                                        value={smsContent}
                                        onChange={(e) => setSmsContent(e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        sx={{ width: '100%' }}/>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="standard" fullWidth>
                                    <TextField
                                        id="recipient-details"
                                        label={t('RecipientDetails')}
                                        multiline
                                        minRows={20}
                                        value={recipientDetails}
                                        onChange={(e) => setRecipientDetails(e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        sx={{ width: '100%' }}/>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Box sx={{ mt: 2, px: 1 }}>
                        <Button variant="contained" onClick={handleSendClick}>{t('Send')}</Button>
                    </Box>
                </Container>
            </Container>
            <AlertSimpleDialog
                title={t('Sending sms')}
                message={t('send-confirm-msg')}
                open={shownSendDialog}
                onClose={handleSendDialogClose}
            />
        </Page>
    )
}
